/* eslint-disable no-console */
import { isOverlayLayer, matchLayerIdentifier, PrimitiveRole, PrimitiveType, } from "@buildwithflux/models";
import { mat3 } from "../../../common";
export function createPrimitivesForLine(node, stackup) {
    // Note: ?? mat3.makeIdentity() is needed to support some testsuites like createShapesForNode_SNAPSHOT
    const transform = node.bakedRules.transformRelativeToShapesLayer ?? mat3.makeIdentity();
    const transformInverse = mat3.invert(transform);
    const layerId = stackup.find((layer) => isOverlayLayer(layer) && matchLayerIdentifier(layer, node.bakedRules.layer))?.uid ??
        null;
    const thickness = node.bakedRules.strokeWidth ?? 0;
    return [
        {
            type: PrimitiveType.Line,
            startX: node.bakedRules.startPosition.x,
            startY: node.bakedRules.startPosition.y,
            endX: node.bakedRules.endPosition.x,
            endY: node.bakedRules.endPosition.y,
            thickness,
            transform,
            transformInverse,
            layerId,
            role: PrimitiveRole.silkScreen,
        },
    ];
}
//# sourceMappingURL=createPrimitivesForLine.js.map